var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"reactAPP",attrs:{"data-react-app":""}},[_vm._v("这里是react渲染的程序")])}
var staticRenderFns = []

export { render, staticRenderFns }